import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { node } from 'prop-types';
import { useAuth } from './AuthProvider';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ padding: '2rem', color: '#fff' }}>Checking session...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: node.isRequired,
};

export default ProtectedRoute;
